import React from 'react';
import ArticleIntroductionQuiz from './ArticleIntroductionQuiz.jsx';

const REVIEW_LABELS = Object.freeze({ entrance: 'Article entrance', pun: 'Wordplay and pun', allit: 'Alliteration' });
const SKILLS = Object.freeze(['entrance', 'pun', 'allit', 'mixed']);

// Only the validated supplement bundle is supplied by the entitled reader. The
// shared native quiz renderer still checks actual lesson linkage and entitlement.
export default function ArticleIntroductionSupplementQuiz(props) {
    return <ArticleIntroductionQuiz {...props} reviewLabels={REVIEW_LABELS} allowedSkills={SKILLS}
        practiceLabel="Supplement foundation practice" lessonLabel="Introduction supplement"
        ariaLabel="Introduction supplement foundation practice" />;
}
